import { useEffect, useState } from 'react';
import { TriangleAlert } from 'lucide-react';
import { api } from '../api';

/* =====================================================================
   El ámbar en el gemelo · TC-20
   =====================================================================
   `GET /api/baldas/ambar` trae todas las lecturas sin reconocer; aquí
   se filtran las de esta repisa. Reconocerlas se hace en «Baldas».
   ===================================================================== */
export default function AmbarDeLaEstacion({ ubicacion }) {
  const [lecturas, setLecturas] = useState([]);
  useEffect(() => {
    let vivo = true;
    api.get('/baldas/ambar').then((l) => { if (vivo) setLecturas((l || []).filter((x) => !ubicacion || x.ubicacion === ubicacion)); }).catch(() => {});
    return () => { vivo = false; };
  }, [ubicacion]);
  if (lecturas.length === 0) return null;
  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 p-3 text-sm">
      <p className="flex items-center gap-2 font-semibold text-amber-900"><TriangleAlert className="h-4 w-4" aria-hidden="true" /> {lecturas.length} lectura(s) de báscula en ámbar en esta repisa</p>
      <ul className="mt-1 text-amber-900">{lecturas.slice(0, 5).map((l) => (
        <li key={l.id}>{String(l.ocurrido_en).slice(11, 16)} · {l.producto}: {l.piezas_antes ?? '?'} → {l.piezas} ({l.delta_piezas > 0 ? '+' : ''}{l.delta_piezas})</li>))}</ul>
      <p className="mt-1 text-xs">No movieron inventario. Se reconocen en Planta y aparatos → Baldas.</p>
    </div>
  );
}
